import { render, staticRenderFns } from "./XAppButton.vue?vue&type=template&id=7c13d9ae"
import script from "./XAppButton.vue?vue&type=script&lang=js"
export * from "./XAppButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports